class SanjarProductFilm extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.track = this.querySelector('[data-film-track]');
    if (!this.track) return;
    this.slides = [...this.track.children];
    this.pauseButton = this.querySelector('[data-film-pause]');
    this.paused = false;
    this.visible = false;
    this.hovered = false;
    this.focused = false;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.querySelector('[data-film-prev]')?.addEventListener('click', () => { this.setPaused(true); this.move(-1); }, { signal });
    this.querySelector('[data-film-next]')?.addEventListener('click', () => { this.setPaused(true); this.move(1); }, { signal });
    this.pauseButton?.addEventListener('click', () => this.setPaused(!this.paused), { signal });
    this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, { signal });
    this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
    this.track.addEventListener('pointerdown', () => this.setPaused(true), { signal, passive: true });
    this.track.addEventListener('wheel', () => this.setPaused(true), { signal, passive: true });
    this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
    this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, { signal });
    this.track.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); this.setPaused(true); this.move(event.key === 'ArrowRight' ? 1 : -1);
    }, { signal });
    document.addEventListener('visibilitychange', () => this.schedule(), { signal });
    this.motion.addEventListener('change', () => this.schedule(), { signal });
    this.addEventListener('shopify:section:select', () => this.setPaused(true), { signal });
    this.observer = new IntersectionObserver(entries => { this.visible = entries[0]?.isIntersecting; this.schedule(); }, { threshold: 0.15 });
    this.observer.observe(this);
  }
  disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); clearTimeout(this.timer); }
  setPaused(paused) {
    this.paused = paused;
    if (this.pauseButton) {
      this.pauseButton.textContent = paused ? 'Play' : 'Pause';
      this.pauseButton.setAttribute('aria-pressed', String(paused));
      this.pauseButton.setAttribute('aria-label', paused ? 'Play automatic slides' : 'Pause automatic slides');
    }
    this.schedule();
  }
  move(direction) {
    const left = this.track.getBoundingClientRect().left;
    let index = 0, distance = Infinity;
    this.slides.forEach((slide, i) => { const delta = Math.abs(slide.getBoundingClientRect().left - left); if (delta < distance) { distance = delta; index = i; } });
    const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    const next = direction > 0 && atEnd ? 0 : (index + direction + this.slides.length) % this.slides.length;
    const slide = this.slides[next];
    if (slide) this.track.scrollBy({ left: slide.getBoundingClientRect().left - left, behavior: this.motion.matches ? 'instant' : 'smooth' });
  }
  schedule() {
    clearTimeout(this.timer);
    if (this.dataset.autoplay !== 'true' || this.paused || this.hovered || this.focused || !this.visible || document.hidden || this.motion.matches || this.slides.length < 2) return;
    this.timer = setTimeout(() => { this.move(1); this.schedule(); }, Number(this.dataset.interval) || 6000);
  }
}
if (!customElements.get('sl-product-film')) customElements.define('sl-product-film', SanjarProductFilm);
